import React, { useEffect } from 'react';
import savedCheckmark from '../../ASUPhotos/icons/me3_GreenCheckMark.svg';

const ChangesSaved = (props) => {
  useEffect(() => {
    if (props.stateValToDetermineShowing) {
      const srMessage = document.getElementById(
        `screen-reader-message${props.idValue}`
      );
      srMessage.innerText = props.message;
    }
  }, [props.stateValToDetermineShowing]);

  const imgStyle = {
    visibility: props.successStatus ? 'visible' : 'hidden',
  };

  return (
    <>
      <div
        style={{
          position: 'absolute',
          marginLeft: '-10000px',
          height: '1px',
          width: '1px',
          color: 'transparent',
        }}
        id={`screen-reader-message${props.idValue}`}
        aria-live="assertive"
        className="visually-hidden"
        aria-atomic="true"
        aria-relevant="all"
        tabIndex={-1}
        role="alert"
      />
      {props.typeOfMessage === 'email' ? (
        <span
          aria-hidden
          className={
            props.stateValToDetermineShowing
              ? 'user-profile__changes-saved fade'
              : 'user-profile__changes-saved'
          }
        >
          <img
            alt="Checkmark"
            src={savedCheckmark}
            className="user-profile__checkmark-icon"
            style={imgStyle}
          />
          {props.message}
        </span>
      ) : (
        <span
          aria-hidden
          className={
            props.stateValToDetermineShowing
              ? 'edit-profile__changes-saved fade flex-fade'
              : 'edit-profile__changes-saved'
          }
        >
          <img
            alt="Checkmark"
            src={savedCheckmark}
            className="edit-profile__checkmark-icon"
          />
          {props.message}
        </span>
      )}
    </>
  );
};

export default ChangesSaved;
